import { render, staticRenderFns } from "./HelpViewPage.vue?vue&type=template&id=68c4cd3e&scoped=true&"
import script from "./HelpViewPage.vue?vue&type=script&lang=js&"
export * from "./HelpViewPage.vue?vue&type=script&lang=js&"
import style0 from "./HelpViewPage.vue?vue&type=style&index=0&id=68c4cd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4cd3e",
  null
  
)

export default component.exports